import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from "../../mutation-types";
import apiVoucher from "@/api/voucher";
import moment from "moment";

const defaultState = () => ({
    konfirmResponse: {},
    voucherData: {},
    dataListVoucher: [],
    pagination: {},
    alert: '',
    isSuccess: false,
    alertTitle: 'Oops!',
    progress: false,
    readonly: false,
    checkVoucherResponse: false,
});

const state = defaultState();

const getters = {};

const mutations = {
    listDataVoucher(state, data) {
        state.dataListVoucher = {};
        state.pagination = {};
        state.dataListVoucher = data.data;
        state.pagination = data.pagination;
    },
    listVoucher(state, data) {
        state.voucherData = {};
        state.voucherData = data;
    },
    saveConfirmResponse(state, data) {
        state.konfirmResponse = {};
        state.konfirmResponse = data;
    },
    setAlert(state, alert) {
        state.isSuccess = false;
        state.alert = alert;
        state.alertTitle = 'Oops!';
    },
    setSuccess(state, alert) {
        state.isSuccess = true;
        state.alert = alert;
        state.alertTitle = 'Berhasil';
    },
    claimProgress(state, data) {
        state.progress = data;
    },
    setReadOnly(state, data) {
        state.readonly = data;
    },
    setCheckVoucher(state, data) {
        state.checkVoucherResponse = data;
    },
    reset(state) {
		Object.assign(state, defaultState());
	},
};

const actions = {
    getDataVoucher({ commit }, value){
        commit(PROGRESS_START, null, { root: true });
        if (value.params.length > 0) {
            let parameterObject = {}
            let parameter = "{"
            value.params.forEach((value, index) => {
                for (const [key, val] of Object.entries(value)) {
                    parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`;
                }
            });
            parameter = parameter.slice(0, -1);
            parameter += `,"limit": "${value.limit}", "page": "${value.page}"`
            parameter += "}";
            parameterObject = JSON.parse(parameter);
            apiVoucher.dataVoucher(parameterObject).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listDataVoucher', { data: 'error', pagination: data.pagination, product: 'error', summary: 'error' });
                } else {    
                    commit("listDataVoucher", { data: data.results, pagination: data.pagination, product: data.product, summary: data.summary });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        } else {
            apiVoucher.dataVoucher({ 'limit': value.limit, 'page': value.page }).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listDataVoucher', { data: 'error', pagination: data.pagination, product: 'error', summary: 'error' });
                } else {
                    commit("listDataVoucher", { data: data.results, pagination: data.pagination, product: data.product, summary: data.summary});
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        }
    },
    getVoucher({ commit }, params) {
        commit(PROGRESS_START, null, { root: true });
        apiVoucher.checkVoucher(params).then(( { data } ) => {
            if(data.code == 200) {
                let dateNow = new Date().getTime();
                let expiredDate = new Date(data.data.voucher_expired_datetime).getTime();
                let expiredDateFormatted = moment(data.data.voucher_expired_datetime).format('dddd, DD MMMM YYYY');

                if(dateNow > expiredDate){
                    commit("setAlert", "Voucher sudah expired sejak " + expiredDateFormatted);
                    commit("listVoucher", data.data);
                    commit("setCheckVoucher", false);
                } else if(data.data.voucher_is_redeem == 1){
                    commit("setAlert", "Voucher sudah di klaim");
                    commit("listVoucher", data.data);
                    commit("setCheckVoucher", false);
                } else {
                    commit("setReadOnly", true);
                    commit("setSuccess", "Voucher tersedia dan dapat di klaim");
                    commit("listVoucher", data.data);
                    commit("setCheckVoucher", true);
                }
            } else {
                commit("setAlert", "Pemilik serial tidak valid");
                commit("listVoucher", {});
                commit("setCheckVoucher", false);
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const data = err.response.data.data
            commit("setReadOnly", false);
            if(err.response.data.message == 'error_validation'){
                commit("listVoucher", {});
                commit("saveConfirmResponse", data);
                commit("setCheckVoucher", false);
            } else {
                commit("listVoucher", {});
                commit('setAlert', 'Voucher tidak ditemukan');
                commit("setCheckVoucher", false);
            }
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    submitVoucher({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        commit('reset');
        commit('claimProgress', true)
        apiVoucher.claimVoucher(value).then(res => {
            if(res.data.code){
                commit("setSuccess", "Voucher berhasil di klaim");
                commit('claimProgress', false)
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(err => {
            const data = err.response.data.message;
            commit('setAlert', err.response.data.message);
            commit("saveConfirmResponse", data);
            commit('claimProgress', false)
            commit(PROGRESS_FAIL, null, { root: true });
        })
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};